import axios from 'axios'

const baseURL = process.env.REACT_APP_API_URL

//console.log('baseURL', baseURL)

const httpClient = axios.create({
    baseURL: baseURL,
    headers: {'Access-Control-Allow-Origin': '*'}
})

class ApiService {

    constructor(apiurl){
        this.apiurl = apiurl;
    }

    post(url, objeto){
       const requestUrl = `${this.apiurl}${url}`
       return httpClient.post(requestUrl, objeto);
    }

    put(url, objeto){
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.put(requestUrl, objeto);
    }

    get(url){
        const requestUrl = `${this.apiurl}${url}`
        return httpClient.get(requestUrl);
     }
}
export default ApiService;